import EditIcon from '../../../../../assets/icons/icon-pen-blue.svg';
import DeleteIcon from '../../../../../assets/icons/icon-cross-red.svg';
import { EntityNames } from "../../../../../enums/EntityNames"
import SidePanelList from "./SidePanelList"
import { FilterMatchType } from '../../../../../enums/FilterMatchType';
import { PropertyTypes } from '../../../../../enums/PropertyTypes';
import { IFilter } from '../../../../../hooks/UseFilters';
import { usePermissions } from '../../../../../modules/auth/Permissions/PermissionContext';
import { hasPermission } from '../../../../../modules/auth/Permissions/PermissionModule';
import { PermissionConcerns, PermissionTypes } from '../../../../../modules/auth/Permissions/PermissionStrings';

interface ISidePanelPackingBoxRanges {
    id: string,
    editRangeFunction: (id: string) => void,
    rangeData: IPackingBoxRange | undefined,
    onAddNewClicked: Function,
    onItemRemoved?: (item: IPackingBoxRange) => void
}

export interface IPackingBoxRange {
    id: string,
    displayName: string,
    year?: string, // Backend returns Year as a string (e.g., "2023" or "2023 > 2024")
    yearStart?: number, // Optional: for backwards compatibility or when coming from Get endpoint
    yearEnd?: number, // Optional: for backwards compatibility or when coming from Get endpoint
    prefix: string,
}

export default function SidePanelPackingBoxRanges(props: ISidePanelPackingBoxRanges) {

    const { id, onAddNewClicked, editRangeFunction, rangeData, onItemRemoved } = props;
    const { permissions } = usePermissions();
    
    const canManageRange = hasPermission(permissions!, PermissionTypes.write, PermissionConcerns.Manage_Range);

    function displayYears(range: IPackingBoxRange) {
        if (range.yearStart !== undefined && range.yearEnd !== undefined) {
            if (range.yearStart === range.yearEnd) {
                return range.yearStart.toString();
            }
            return `${range.yearStart} > ${range.yearEnd}`;
        }

        // Backend List endpoint returns year as a string, use it directly if nothing else available
        if (range.year) {
            return range.year;
        }
        return '';
    }

    return (
        <SidePanelList<IPackingBoxRange>
            id={id}
            entityName={EntityNames.ranges}
            searchLabel={"Enter a year"}
            onAddNewClicked={onAddNewClicked}
            editFunction={editRangeFunction}
            itemData={rangeData}
            onItemRemoved={onItemRemoved}
            canAdd={canManageRange}
            canEdit={canManageRange}
            canDelete={canManageRange}
            loadingRowCount={4}
            searchFilter={(searchVal?: string | undefined) => {
                return {
                    propertyName: "Year",
                    value: searchVal,
                    required: false,
                    matchType: FilterMatchType.Equal,
                    type: PropertyTypes.year
                } as IFilter
            }}
            renderRowContent={(item, edit, remove) => (
                <>
                    <td>
                        <div className="side-panel-table__cell-content">
                            <p className="small small--2">{displayYears(item)}</p>
                        </div>
                    </td>
                    <td style={{ minWidth: '200px' }}>
                        <div className="side-panel-table__cell-content">
                            <p className="small small--2">{item.displayName}</p>
                        </div>
                    </td>
                    <td>
                        <div className="display--flex gap--m justifyContent--flex-end">
                            {edit &&
                                <div className="cursor__pointer side-panel-table__cell-content display--flex justifyContent--flex-end" onClick={() => edit(item.id)}>
                                    <img className="small-1" src={EditIcon} />
                                </div>
                            }
                            {remove &&
                                <div className="cursor__pointer side-panel-table__cell-content display--flex justifyContent--flex-end" onClick={() => remove(item)}>
                                    <img className="small-1" src={DeleteIcon} />
                                </div>
                            }
                        </div>
                    </td>
                </>
            )}
            displayColumns={
                <>
                    <th><p className="small">Years</p></th>
                    <th style={{ minWidth: '200px' }}><p className="small">Case Numbers</p></th>
                    <th><p className="small"></p></th>
                </>
            }
        />
    );
}